import { UpdateMasterPairing, UpdateMasterPairingVariables } from './__generated__/UpdateMasterPairing'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateMasterPairing($input: MasterPairingInputV2!) {
    updateMasterPairing: updateMasterPairingV2(input: $input) {
      ... on MasterPairingV2 {
        id
        boardId
        deviceId
        personFirstName
        personLastName
        accountId
        accountEmailAddress
        boardTitle
        createdAt
        dealId
        deviceId
        hubspotMessage
        hubspotUpdated
        manualReviewFlag
        manualReviewMessage
        memberIds
        memberEmailAddresses
        pairingDate
        personId
        plusApplicationDate
        plusRenewalDate
        plusRenewalFrequency
        synced
      }
      ... on MasterPairingErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateMasterPairing = () => useMutation<UpdateMasterPairing, UpdateMasterPairingVariables>(MUTATION)
